/* global globalThis */

// This file provides a small process shim for browser-only bundles.
// Some third-party code checks bare `process`, not only `window.process`.

const processShim = {
  env: {
    NODE_ENV: (typeof window !== 'undefined' && window.process && window.process.env && window.process.env.NODE_ENV) || 'production',
    // Environment variables should be set at build time via .env files.
    // DO NOT hardcode API keys or secrets here.
  },
  browser: true,
  version: '',
  versions: {},
  nextTick: (callback, ...args) => Promise.resolve().then(() => callback(...args)),
};

if (typeof window !== 'undefined') {
  if (!window.process) window.process = processShim;
  if (!window.global) window.global = window;
  window.global.process = window.process;
}
if (typeof globalThis !== 'undefined') {
  globalThis.process = (typeof window !== 'undefined' && window.process) ? window.process : processShim;
}

export default {};
